import { API_SOCKET } from 'config/api.config';
import { useNapBus } from 'context';
import { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { io } from 'socket.io-client';

const WebSocket = createContext({ socket: null });
export const useWebSocket = () => useContext(WebSocket);

export const WebSocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const [socket, setSocket] = useState(null);
  const { company } = useNapBus();

  useEffect(() => {
    if (!company?._id) return;

    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current = null;
      setSocket(null);
    }

    const s = io(API_SOCKET, {
      withCredentials: true,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      auth: { companyId: company._id },
    });

    socketRef.current = s;
    setSocket(s);

    s.on('connect', () => console.log('🟢 WS connect', s.id, 'company', company._id));
    s.on('disconnect', (r) => console.log('🔴 WS disconnect', r));
    s.on('connect_error', (e) => console.log('⚠️ WS connect_error', e?.message));

    return () => {
      s.disconnect();
      socketRef.current = null;
      setSocket(null);
    };
  }, [company?._id]); // 👈 CLAVE

  const value = useMemo(() => ({ socket }), [socket]);

  return <WebSocket.Provider value={value}>{children}</WebSocket.Provider>;
};
